import _cloneDeep from 'lodash/cloneDeep';

const RadioIcons = {
    'VALUE_0': 'icon_signal0',
    'VALUE_1': 'icon_signal1',
    'VALUE_2': 'icon_signal2',
    'VALUE_3': 'icon_signal3',
    'VALUE_4': 'icon_signal4',
    'VALUE_5': 'icon_signal5'
};

export default class RadioStatusController {
    $onInit() {
        if (!this.radio) {
            this.radioIcon = RadioIcons.VALUE_0;
        }
    }

    $onChanges(changes) {
        if (changes.radio && !isNaN(parseInt(changes.radio.currentValue, 10))) {
            this.radio = parseInt(_cloneDeep(changes.radio.currentValue), 10);
        } else {
            this.radio = 0;
        }

        this.calculateIcon();
    }

    calculateIcon() {
        this.radioIcon = RadioIcons[`VALUE_${this.radio}`];
    }
}



// WEBPACK FOOTER //
// ./app/common/radio-status/radio-status.controller.js